import { useCallback } from "react";
import type { AgreementSignature } from "../../../../common/src";
import { USER_AGREEMENT } from "../../../../common/src";
import { useAction } from "../../hooks/useAction";
import { useCurrentUser, useSession } from "../../session/SessionContext";
import { trpc } from "../../trpc";
import { AuthLayout } from "../auth/AuthLayout";
import { Button } from "../shared/Button";
import { AgreementSigner } from "./AgreementSigner";

/** Shown to a signed-in veteran until they accept the current User Agreement version. */
export const AgreementPage = () => {
  const user = useCurrentUser();
  const { signedIn, signOut } = useSession();
  const sign = useAction(
    useCallback(
      (input: AgreementSignature) => trpc.auth.signAgreement.mutate(input),
      []
    )
  );

  return (
    <AuthLayout width={760}>
      <h2>Welcome, {user.displayName}</h2>
      <p>
        Before you can use VetBoats, please read the agreement below in full and
        sign it. We'll email a copy of what you signed to {user.email}.
      </p>
      <AgreementSigner
        doc={USER_AGREEMENT}
        submitLabel="Sign agreement"
        pending={sign.pending}
        error={sign.error}
        onSign={async (signature) => {
          const updated = await sign.run(signature);
          if (updated) {
            signedIn(updated);
          }
        }}
      />
      <p>
        <Button variant="ghost" small onClick={() => void signOut()}>
          Sign out
        </Button>
      </p>
    </AuthLayout>
  );
};
